import { useState } from "react";
import { ChevronDown, Check } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "../ui/command";
import { flagOf } from "../../lib/journey";

export const CountryPicker = ({ countries, priority, value, onChange, showDial, testId, className = "" }) => {
  const [open, setOpen] = useState(false);
  const current = countries.find((c) => c.iso === value);
  const top = priority.map((p) => countries.find((c) => c.iso === p)).filter(Boolean);
  const rest = countries.filter((c) => !priority.includes(c.iso));

  const item = (c) => (
    <CommandItem
      key={c.iso}
      value={`${c.name} ${c.iso} +${c.dial}`}
      onSelect={() => {
        onChange(c.iso);
        setOpen(false);
      }}
      className="min-h-[44px]"
      data-testid={`${testId}-option-${c.iso}`}
    >
      <span className="mr-2 text-lg">{flagOf(c.iso)}</span>
      <span className="flex-1">{c.name}</span>
      {showDial && <span className="text-neutral-500">+{c.dial}</span>}
      {value === c.iso && <Check className="ml-2 h-4 w-4 text-[#138808]" />}
    </CommandItem>
  );

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={`flex h-12 items-center gap-2 rounded-2xl border border-neutral-200 bg-white px-3 text-[15px] outline-none transition-colors focus:border-[var(--saffron)] ${className}`}
          data-testid={testId}
        >
          {current ? (
            <>
              <span className="text-lg">{flagOf(current.iso)}</span>
              <span className={showDial ? "" : "flex-1 truncate text-left"}>{showDial ? `+${current.dial}` : current.name}</span>
            </>
          ) : (
            <span className="flex-1 text-left text-neutral-400">Select</span>
          )}
          <ChevronDown className="ml-auto h-4 w-4 text-neutral-400" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[min(92vw,340px)] p-0" align="start">
        <Command>
          <CommandInput placeholder="Search country or code" data-testid={`${testId}-search`} />
          <CommandList className="max-h-72">
            <CommandEmpty>No country found.</CommandEmpty>
            <CommandGroup heading="Popular with NRIs">{top.map(item)}</CommandGroup>
            <CommandGroup heading="All countries">{rest.map(item)}</CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
